<template>
  <router-view />
</template>

<style lang="scss">
@use '@styles/styles.scss';

</style>
